import React from 'react';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import bootstrap from './bootstrap';
import { render } from 'react-dom';
import { ReactDOM } from 'react-dom';
import { createRoot } from 'react-dom/client';


bootstrap();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
